// extracted by mini-css-extract-plugin
export default {"tx":"_196b65a85e","line":"_7b40487cd7"};